export enum TextureType {
    Anisotropy = "Anisotropy",
    AnisotropyRotation = "AnisotropyRotation",
    AnisotropyStrength = "AnisotropyStrength",
    Diffuse = "Diffuse",
    DiffuseRoughness = "DiffuseRoughness",
    Displacement = "Displacement",
    Error = "Error",
    F0 = "F0",
    Ior = "Ior",
    Mask = "Mask",
    Metalness = "Metalness",
    Normal = "Normal",
    Roughness = "Roughness",
    SpecularStrength = "SpecularStrength",
    SpecularTint = "SpecularTint",
    Transmission = "Transmission",
}

/** @deprecated Use TextureType instead */
export enum LegacyTextureType {
    Anisotropy = "Anisotropy",
    AnisotropyRotation = "AnisotropyRotation",
    AnisotropyStrength = "AnisotropyStrength",
    Diffuse = "Diffuse",
    DiffuseRoughness = "DiffuseRoughness",
    Displacement = "Displacement",
    Error = "Error",
    F0 = "F0",
    Ior = "IOR",
    Mask = "Mask",
    Metalness = "Metalness",
    Normal = "Normal",
    Roughness = "Roughness",
    SpecularStrength = "SpecularStrength",
    SpecularTint = "SpecularTint",
    Transmission = "Transmission",
}
